import { makeStyles } from "@mui/styles";
import { FormikTextField, Section } from "components/disw";
import { FormikErrors } from "formik";
import { LimitType } from "model/schema/globalTypes";
import React from "react";
import theme from "utils/theme";
import SelectComboBox from "../SelectComboBox";
import { ServiceProductCreatable } from "./types";

interface LimitSectionProps {
  values: Partial<ServiceProductCreatable>;
  errors: FormikErrors<ServiceProductCreatable>;
  setFieldValue: (
    field: string,
    value: unknown,
    shouldValidate?: boolean
  ) => void;
}

const useStyles = makeStyles(() => ({
  limit: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2)
  }
}));

const LimitSection: React.FC<LimitSectionProps> = ({
  values,
  errors,
  setFieldValue
}) => {
  const classes = useStyles();
  return (
    <Section name="Limit">
      <div className={classes.limit}>
        <SelectComboBox<{ name: string }>
          label="Limit Type"
          items={[{ name: LimitType.Soft }, { name: LimitType.Hard }]}
          valueExpr="name"
          displayExpr="name"
          placeholder="Select Limit Type"
          onValueChanged={e => {
            if (e.value) setFieldValue("limitType", e.value);
          }}
          value={values.limitType}
          isError={Boolean(errors.limitType)}
          errorText={errors.limitType as string}
        />
        <FormikTextField
          name="transactionLimit"
          label="Transaction Limit"
          placeholder="Enter Number of Transactions"
          onChange={e => {
            setFieldValue("transactionLimit", Number(e.target.value));
          }}
          type="number"
          error={Boolean(errors.transactionLimit)}
          errorMessage={
            typeof errors.transactionLimit === "string"
              ? errors.transactionLimit
              : undefined
          }
        />
      </div>
    </Section>
  );
};

export default LimitSection;
